enum BrandFanFilters {
  All = 'all',
  BrandFans = 'brand_fans',
  Groups = 'groups',
}

export { BrandFanFilters }
